module.exports = __webpack_public_path__ + "static/media/Security.1dc35923.jpg";